// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"231":"c9192ac5","267":"60b64e27","431":"531e4b7d","580":"9852e203","653":"cb70276d"}[chunkId] + ".css";
};